// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + "Login_Page" + "." + "8fa4b50a" + ".css"
}